import { render, staticRenderFns } from "./PatientsSelector.vue?vue&type=template&id=7a84763a"
import script from "./PatientsSelector.vue?vue&type=script&lang=js"
export * from "./PatientsSelector.vue?vue&type=script&lang=js"
import style0 from "./PatientsSelector.vue?vue&type=style&index=0&id=7a84763a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports